<div class="table-scroll">
    <table class="table table--compare">
        <ng-content></ng-content>
    </table>
</div>
